export default __webpack_public_path__ + "locales/ar-SA/People.json?hash=dc91f6b4a27a9e4c8579b08d1967fc15";